import { Alert, DialogTitle, Stack, Typography } from "@mui/material";
import { CommonDialog } from "@/components/common/CommonDialog";
import { FormButtonGroup } from "@/components/form";

interface CancelExtensionModalProps {
    isOpen: boolean;
    isLoading: boolean;
    onClose: () => void;
    onConfirm: () => void;
    extensionName: string;
}

export function CancelExtensionModal({
    isOpen,
    isLoading,
    onClose,
    onConfirm,
    extensionName,
}: CancelExtensionModalProps) {
    return (
        <CommonDialog
            isOpen={isOpen}
            handleClose={onClose}
            maxWidth="sm"
        >
            <DialogTitle align="center">
                Tem certeza que deseja desativar a extensão <b>{extensionName}</b>?
            </DialogTitle>

            <Stack spacing={3}>
                <Stack mb={2}>
                    <Alert
                        severity="warning"
                        variant="outlined"
                        sx={{
                            alignItems: "center",
                            fontSize: "1rem",
                            backgroundColor: "#FFF8E1",
                            borderColor: "#FF9800",
                            color: "#7A4F01",
                            justifyContent: "center",
                            textAlign: "center",
                        }}
                        icon={false}
                    >
                        <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
                            <span style={{ color: "#FF9800", fontSize: 24, marginRight: 8 }}>⚠️</span>
                            <Typography variant="subtitle2" fontWeight="500" component="span">
                                Ao confirmar, todos os recursos e benefícios dessa extensão serão imediatamente removidos para sua clínica.<br />
                            </Typography>
                        </Stack>
                    </Alert>
                </Stack>

                <FormButtonGroup
                    onGoBackButtonClick={onClose}
                    onNextButtonClick={onConfirm}
                    loading={isLoading}
                    goBackButtonText="Fechar"
                    nextButtonText={
                        isLoading ? "Cancelando..." : "Confirmar"
                    }
                    disabled={isLoading}
                    maxWidth
                />
            </Stack>
        </CommonDialog>
    );
}

